<template>
  <div>
    <component-header
      title="Request List"
      :isLoading="loading"
      :hasReload="true"
      @reload-data="reloadData"
      :hasSearch="false"
      :hasback="true"
      @back-press="$router.go(-1)"
      :hasCreate="true"
      @create-press="$router.push({ name: 'CreateRequest' , params:{listData: $route.params.listData}})"
      createButtonText="Create Request"
    />
    <b-card class="card-wrap" border-variant="info">
      <b-row class="justify-content-center">
        <b-col>
          <b-table
            class="text-center tableRadius"
            :items="tableData"
            :fields="fields"
            :bordered="bordered"
            responsive
            :filter="filter"
            thead-class="header"
            :busy="loading"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
          </b-table>
        </b-col>
      </b-row>
    </b-card>
    <div style="float: right">
      <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="tableData.length"
        aria-controls="my-table"
        prev-text="Prev"
        next-text="Next"
        hide-goto-end-buttons
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    ComponentHeader,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      loading: true,
      filter: "",
      sortBy: "",
      sortDesc: true,
      striped: true,
      bordered: true,
      tableData: [],
      fields: [
        { key: "createdAt", label: "Date" },
        { key: "requestFo", label: "Request FO" },
        { key: "issue", label: "Issue" },
        { key: "_id", label: "Id" },
        { key: "status", label: "Status" },
      ],
    };
  },
  methods: {
    ...mapActions(["onboardCustomer/requestListAction"]),
    async fetchRequestList() {
      this.loading = true;
      const payload = {
        id: this.$route.params.id,
      };
      try {
        await this.$store.dispatch(
          "onboardCustomer/requestListAction",
          payload
        );
        this.tableData = this.requestListDataList.map((item) => ({
          createdAt: item?.createdAt || "N/A",
          requestFo: item?.custom?.jobType || "N/A",
          issue: item?.custom?.extraNote || "N/A",
          _id: item?._id || "N/A",
          status: item?.orderStatus === "Delivered" ? "CLOSED" : "OPEN",
        }));
      } catch (error) {
        console.error("Error fetching request list:", error);
      } finally {
        this.loading = false;
      }
    },
    reloadData() {
      this.fetchRequestList();
    },
  },
  mounted() {
    this.fetchRequestList();
    const listData = this.$route.params.listData
  },
  computed: {
    ...mapState({
      requestListDataList: (state) => state.onboardCustomer.requestListData,
    }),
  },
};
</script>
